import { render } from "./AppTopNav.vue?vue&type=template&id=a264635a"
import script from "./AppTopNav.vue?vue&type=script&lang=js"
export * from "./AppTopNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__